import Validator from '../validator';
import YupEmailValidator from './yup-email.validator';

export default class EmailValidator extends Validator {
  static validate(string) {
    return YupEmailValidator(string);
  }
}
